import { Check, Edit } from "@mui/icons-material";
import { Box, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React from "react";

function LoungeDetails({lounge}) {
    return (
        <Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 300, textAlign: 'left', fontWeight: 'bold' }}>
                {lounge?.name}
            </Typography>
            <Table>
                <TableBody>
                <TableRow>
                        <TableCell>
                            Offer:
                        </TableCell>
                        <TableCell>
                            {lounge?.offerId}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Airport:
                        </TableCell>
                        <TableCell>
                            {lounge?.terminal?.airport?.code}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Description:
                        </TableCell>
                        <TableCell>
                            {lounge?.description}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
}

export default LoungeDetails;
